/* What the WMS bills for, as `/wms/fulfillment-provider/:id/rates` returns it. */
export type RateService = {
  name: string;
  uniqueName?: string;
  enabled?: boolean;
  /** False for a service whose category already names it. */
  showTitle?: boolean;
  frequency?: string;
  rate?: number;
  billingUnit?: string;
};

export type RateCategory = {
  name: string;
  services: RateService[];
};

export type RateCardData = {
  categories?: RateCategory[];
};

export type PackagingMaterial = {
  _id?: string;
  name: string;
  packagingType?: string;
  cbf?: number;
  price?: { value?: number; currency?: string };
  length?: number;
  width?: number;
  height?: number;
};

export const ALL_TYPES = 'all';

/** Only what the provider bills: disabled services and empty categories go. */
export function billedCategories(data?: RateCardData): RateCategory[] {
  return (data?.categories ?? [])
    .map(category => ({
      ...category,
      services: (category.services ?? []).filter(service => service.enabled),
    }))
    .filter(category => category.services.length > 0);
}

/** "All types" first, then every packaging type once, in the order they come. */
export function materialTypeOptions(materials: PackagingMaterial[]) {
  const types = [
    ...new Set(materials.map(m => m.packagingType).filter(Boolean)),
  ] as string[];
  return [
    { value: ALL_TYPES, label: 'All types' },
    ...types.map(type => ({ value: type, label: type })),
  ];
}

export function filterMaterials(materials: PackagingMaterial[], type: string) {
  return type === ALL_TYPES
    ? materials
    : materials.filter(m => m.packagingType === type);
}
